"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WorkflowDesignerArrowPathModel = /** @class */ (function () {
    function WorkflowDesignerArrowPathModel() {
        this.matrix1 = null;
        this.matrix2 = null;
        this.labelX = 0;
        this.labelY = 0;
        this.horizontal = false;
        this.coords = [];
        this.minOffset = 4;
        this.maxOffset = 30;
    }
    Object.defineProperty(WorkflowDesignerArrowPathModel.prototype, "left", {
        get: function () {
            return Math.min(this.x1, this.x2) - this.maxOffset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerArrowPathModel.prototype, "right", {
        get: function () {
            return Math.max(this.x1, this.x2) + this.maxOffset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerArrowPathModel.prototype, "top", {
        get: function () {
            return Math.min(this.y1, this.y2) - this.maxOffset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerArrowPathModel.prototype, "bottom", {
        get: function () {
            return Math.max(this.y1, this.y2) + this.maxOffset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerArrowPathModel.prototype, "midX", {
        get: function () {
            return this.x1 + (this.x2 - this.x1) / 2;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerArrowPathModel.prototype, "midY", {
        get: function () {
            return this.y1 + (this.y2 - this.y1) / 2;
        },
        enumerable: true,
        configurable: true
    });
    WorkflowDesignerArrowPathModel.prototype.setValues = function (x1, y1, matrix1, x2, y2, matrix2) {
        this.x1 = x1;
        this.y1 = y1;
        this.matrix1 = matrix1;
        this.x2 = x2;
        this.y2 = y2;
        this.matrix2 = matrix2;
        return this;
    };
    WorkflowDesignerArrowPathModel.prototype.points = function () {
        var c = this.coords;
        c.length = 0;
        this.labelX = this.midX;
        this.labelY = this.midY;
        this.renderBeginMin(this.minOffset);
        if (this.matrix1.dir === this.matrix2.dir) {
            this.renderBeginMax();
            this.renderEndMax();
        }
        else {
            this.renderBeginMin(this.maxOffset);
            this.renderBasicLine();
            this.renderEndMin(this.maxOffset);
        }
        this.renderEndMin(this.minOffset);
        return c.join(',');
    };
    WorkflowDesignerArrowPathModel.prototype.renderBeginMax = function () {
        var c = this.coords;
        switch (this.matrix1.dir) {
            case 0:
                c.push(this.x1, this.top);
                this.labelY = this.top;
                break;
            case 1:
                c.push(this.right, this.y1);
                this.labelX = this.right;
                break;
            case 2:
                c.push(this.x1, this.bottom);
                this.labelY = this.bottom;
                break;
            case 3:
                c.push(this.left, this.y1);
                this.labelX = this.left;
                break;
        }
    };
    WorkflowDesignerArrowPathModel.prototype.renderEndMax = function () {
        var c = this.coords;
        switch (this.matrix2.dir) {
            case 0:
                c.push(this.x2, this.top);
                this.labelY = this.top;
                break;
            case 1:
                c.push(this.right, this.y2);
                this.labelX = this.right;
                break;
            case 2:
                c.push(this.x2, this.bottom);
                this.labelY = this.bottom;
                break;
            case 3:
                c.push(this.left, this.y2);
                this.labelX = this.left;
                break;
        }
    };
    WorkflowDesignerArrowPathModel.prototype.renderBeginMin = function (offset) {
        var c = this.coords;
        switch (this.matrix1.dir) {
            case 0:
                c.push(this.x1, this.y1 - offset);
                break;
            case 1:
                c.push(this.x1 + offset, this.y1);
                break;
            case 2:
                c.push(this.x1, this.y1 + offset);
                break;
            case 3:
                c.push(this.x1 - offset, this.y1);
                break;
        }
    };
    WorkflowDesignerArrowPathModel.prototype.renderEndMin = function (offset) {
        var c = this.coords;
        switch (this.matrix2.dir) {
            case 0:
                c.push(this.x2, this.y2 - offset);
                break;
            case 1:
                c.push(this.x2 + offset, this.y2);
                break;
            case 2:
                c.push(this.x2, this.y2 + offset);
                break;
            case 3:
                c.push(this.x2 - offset, this.y2);
                break;
        }
    };
    WorkflowDesignerArrowPathModel.prototype.renderBasicLine = function () {
        var c = this.coords, x1 = this.x1 + this.matrix1.vectorX * this.maxOffset, y1 = this.y1 + this.matrix1.vectorY * this.maxOffset, x2 = this.x2 + this.matrix2.vectorX * this.maxOffset, y2 = this.y2 + this.matrix2.vectorY * this.maxOffset;
        if (this.matrix1.horizontal && this.matrix2.horizontal) {
            if ((x1 < x2 && this.matrix1.dir === 1) || (x1 > x2 && this.matrix1.dir === 3)) {
                c.push(this.midX, y1, this.midX, y2);
            }
            else {
                c.push(x1, this.midY, x2, this.midY);
            }
        }
        else if (!this.matrix1.horizontal && !this.matrix2.horizontal) {
            if ((y1 < y2 && this.matrix1.dir === 2) || (y1 > y2 && this.matrix1.dir === 0)) {
                c.push(x1, this.midY, x2, this.midY);
            }
            else {
                c.push(this.midX, y1, this.midX, y2);
            }
        }
        else if (this.matrix1.horizontal && !this.matrix2.horizontal) {
            if ((this.matrix1.dir === 1 && this.matrix2.dir === 0 && x2 > x1 && y2 > y1) ||
                (this.matrix1.dir === 1 && this.matrix2.dir === 2 && x2 > x1 && y2 < y1) ||
                (this.matrix1.dir === 3 && this.matrix2.dir === 0 && x2 < x1 && y2 > y1) ||
                (this.matrix1.dir === 3 && this.matrix2.dir === 2 && x2 < x1 && y2 < y1)) {
                c.push(x2, y1);
                this.labelX = x2;
                this.labelY = y1;
            }
            else {
                c.push(x1, y2);
                this.labelX = x1;
                this.labelY = y2;
            }
        }
        else if (!this.matrix1.horizontal && this.matrix2.horizontal) {
            if ((this.matrix1.dir === 2 && this.matrix2.dir === 1 && y2 > y1 && x2 < x1) ||
                (this.matrix1.dir === 2 && this.matrix2.dir === 3 && y2 > y1 && x2 > x1) ||
                (this.matrix1.dir === 0 && this.matrix2.dir === 1 && y2 < y1 && x2 < x1) ||
                (this.matrix1.dir === 0 && this.matrix2.dir === 3 && y2 < y1 && x2 > x1)) {
                c.push(x1, y2);
                this.labelX = x1;
                this.labelY = y2;
            }
            else {
                c.push(x2, y1);
                this.labelX = x2;
                this.labelY = y1;
            }
        }
    };
    WorkflowDesignerArrowPathModel.prototype.detectOneStepDiff = function () {
        var diff = Math.abs(this.matrix1.dir - this.matrix2.dir);
        return diff === 1 || diff === 3;
    };
    WorkflowDesignerArrowPathModel.prototype.isSameVector = function (x1, y1, x2, y2, x3, y3, x4, y4) {
        var v1x = Math.abs(x2 - x1), v1y = Math.abs(y2 - y1), v2x = Math.abs(x4 - x3), v2y = Math.abs(y4 - y3), vx = v2x - v1x, vy = v2y - v1y;
        return Math.sqrt(vx * vx + vy * vy) < 0.1;
    };
    return WorkflowDesignerArrowPathModel;
}());
exports.WorkflowDesignerArrowPathModel = WorkflowDesignerArrowPathModel;
//# sourceMappingURL=workflow-designer-arrow-path.model.js.map